export enum ETypUdalosti {
    VH = 'VH',
    VHODP = 'VHODP',
    VHODPZRUS = 'VHODPZRUS',
    VHZRUS = 'VHZRUS',
    VYPIS = 'VYPIS',
    VYPISODP = 'VYPISODP',
    VYPISZRUS = 'VYPISZRUS',
    POT = 'POT',
    STR = 'STR',
    ZAP = 'ZAP',
    VYSL = 'VYSL',
    JINA = 'JINA'
}
